import { render, staticRenderFns } from "./Form4.vue?vue&type=template&id=ca90e9fa&scoped=true&"
import script from "./Form4.vue?vue&type=script&lang=js&"
export * from "./Form4.vue?vue&type=script&lang=js&"
import style0 from "./Form4.vue?vue&type=style&index=0&id=ca90e9fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca90e9fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
